import { lazy } from 'react';

/**
 * A robust wrapper for React.lazy that reloads the page once on chunk failures.
 */
export const lazyRetry = (importFn) =>
  lazy(async () => {
    const hasRefreshed = sessionStorage.getItem('lazy-retry-refreshed') === 'true';

    try {
      // 1. Try the actual import
      const component = await importFn();

      // Success! Clear the flag so we can retry again in the future if needed
      sessionStorage.removeItem('lazy-retry-refreshed');
      return component;
    } catch (error) {
      // 2. Determine if this is a deployment/chunk error
      const isChunkError = /Loading chunk|Failed to fetch|Importing a module script failed/i.test(
        error.message
      );

      if (isChunkError && !hasRefreshed) {
        // 3. Mark that we are reloading and perform a hard refresh
        sessionStorage.setItem('lazy-retry-refreshed', 'true');
        window.location.reload();

        // 4. Return a "forever pending" promise.
        // This stops React from trying to process the error/null and crashing
        // with "type is invalid" while the page is in the middle of refreshing.
        return new Promise(() => {});
      }

      // 5. If it's a real code error (syntax, etc.), let your Error Boundary handle it
      throw error;
    }
  });
